<template>
    <div class="lazy-promotions">
        <in-view-lazy-component name="Promotions" :fetch-data="{ url }" @response="onResponse" @error="onError">
            <template #loading>
                <div
                    class="skeleton skeleton--animation_pulse skeleton--size_md grid__wrapper grid__wrapper--nowrap grid__wrapper--no-gutter overflow-hidden"
                >
                    <div class="grid__item grid__item-12/12">
                        <div
                            class="grid__item skeleton__bone skeleton__bone--image skeleton__bone--rounded skeleton__bone--image-x7 skeleton__bone--width_full"
                        ></div>
                    </div>
                </div>
            </template>
            <template #default="{ component, response }">
                <component
                    :is="component"
                    :items="(response.data && response.data.data && response.data.data.items) || []"
                    :analytics="(response.data && response.data.data && response.data.data.analytics) || {}"
                    v-on="$listeners"
                />
            </template>
        </in-view-lazy-component>
    </div>
</template>

<script>
import { getApiUrl } from '@v4/config';
import { stringifyUrl } from '@v4/common/utils/url';
import InViewLazyComponent from '@v4/common/components/atoms/InViewLazyComponent';

export default {
    name: 'LazyPromotions',
    components: {
        InViewLazyComponent,
    },
    props: {
        /**
         * Make name
         */
        make: {
            type: String,
            default: '',
        },
        /**
         * Model name
         */
        model: {
            type: String,
            default: '',
        },
        /**
         * Google Analytics action list for `dataLayer`
         */
        gaActionList: {
            type: String,
            default: '',
        },
        /**
         * The version ID
         */
        versionHistoricalId: {
            type: String,
            default: '',
        },
    },
    computed: {
        url() {
            return stringifyUrl({
                url: `${getApiUrl()}/dkwp/v3/offers/vdp-offers-box/${this.make}/${this.model}/`,
                query: {
                    ga_action_list: this.gaActionList, // eslint-disable-line camelcase
                    ...(this.versionHistoricalId && { versionHistoricalId: this.versionHistoricalId }),
                },
            });
        },
    },
    methods: {
        onResponse(...args) {
            /**
             * Fired when getting success response from `FetchData` component
             *
             * @event response
             * @type {object}
             * @property {object} payload - Payload data
             */
            this.$emit('response', ...args);
        },
        onError(...args) {
            /**
             * Fired when getting error response from `FetchData` component
             *
             * @event error
             * @type {object}
             * @property {object} payload - Payload data
             */
            this.$emit('error', ...args);
        },
    },
};
</script>

<style lang="scss" src="@v4/multi-section/components/molecules/LazyPromotions/_index.scss"></style>
